// TODO: will remove production in the future
export const isMSWEnabledEnvironment =
  process.env.VERCEL_ENV === 'preview' || process.env.NODE_ENV === 'development';
